import { defineComponent as _defineComponent } from 'vue';
import { watch, getCurrentInstance, reactive } from 'vue';
import { useAttendanceRecordStore } from '@blade-sxp/record-center/store/attendanceStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'attendanceDetail',
    setup(__props) {
        const store = useAttendanceRecordStore();
        const vm = getCurrentInstance()?.proxy;
        const pageParam = reactive({
            portraitId: '',
            attendanceDate: '',
        });
        const detailData = reactive({
            list: [],
            department: '',
            identityId: '',
            name: '',
            originImage: '',
        });
        watch(() => vm?.$route.query, (nv) => {
            pageParam.portraitId = nv?.id;
            pageParam.attendanceDate = nv?.date;
            detailData.department = nv?.department;
            detailData.identityId = nv?.jobNumber;
            initData();
        }, { deep: true, immediate: true });
        async function initData() {
            try {
                const { capturedInfoList = [], portraitInfo = {} } = await store.getAttendanceDetail(pageParam);
                detailData.department = portraitInfo?.department || detailData.department;
                detailData.identityId = portraitInfo?.identityId || detailData.identityId;
                detailData.name = portraitInfo?.name;
                detailData.originImage = portraitInfo?.originImage;
                detailData.list = capturedInfoList;
            }
            catch (e) {
                console.log(e);
            }
        }
        return { __sfc: true, store, vm, pageParam, detailData, initData };
    }
});
